import React from 'react'

export default props => (
  <svg viewBox="0 0 18 19" {...props}>
    <path d="M12,9 L12,3 L9,0 L6,3 L6,5 L0,5 L0,19 L18,19 L18,9 L12,9 Z M4,17 L2,17 L2,15 L4,15 L4,17 Z M4,13 L2,13 L2,11 L4,11 L4,13 Z M4,9 L2,9 L2,7 L4,7 L4,9 Z M10,17 L8,17 L8,15 L10,15 L10,17 Z M10,13 L8,13 L8,11 L10,11 L10,13 Z M10,9 L8,9 L8,7 L10,7 L10,9 Z M10,5 L8,5 L8,3 L10,3 L10,5 Z M16,17 L14,17 L14,15 L16,15 L16,17 Z M16,13 L14,13 L14,11 L16,11 L16,13 Z" />
  </svg>
)
